export const OPPORTUNITIES_RESET_STATE = 'OPPORTUNITIES_RESET_STATE';
export const OPPORTUNITIES_CURRENT_ITEM = 'OPPORTUNITIES_CURRENT_ITEM';

export const OPPORTUNITIES_REQUEST_LOADING = 'OPPORTUNITIES_REQUEST_LOADING';
export const OPPORTUNITIES_REQUEST_SUCCESS = 'OPPORTUNITIES_REQUEST_SUCCESS';
export const OPPORTUNITIES_REQUEST_FAILED = 'OPPORTUNITIES_REQUEST_FAILED';

export const OPPORTUNITIES_CURRENT_ACTION = 'OPPORTUNITIES_CURRENT_ACTION';
export const OPPORTUNITIES_RESET_ACTION = 'OPPORTUNITIES_RESET_ACTION';
